import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

// STYLES
import { StatisticItemContainer } from './styles';

const StatisticItem = ({ title, titleColor, text }) => {
  return (
    <StatisticItemContainer className="statistic-item">
      <Typography className={`text-color text-color--${titleColor}`} variant="h3" component="b">
        {title}
      </Typography>
      <p className="p4">{text}</p>
    </StatisticItemContainer>
  );
};

StatisticItem.propTypes = {
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default React.memo(StatisticItem);
